export default __webpack_public_path__ + "static/media/bookmark.783421f4.svg";